import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/experience', label: 'Experience' },
  { to: '/about', label: 'About' },
  { to: '/media', label: 'Media' },
  { to: '/contact', label: 'Contact' },
];

const WB_LOGO = 'https://customer-assets.emergentagent.com/job_110eaf2c-e2da-4799-9c05-6d381eae4282/artifacts/13g1t9qc_BBEED318-098A-4FB8-8AEB-680648F471A0.jpeg';

export default function SiteHeader() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-gray-950/95 backdrop-blur-md border-b border-gray-800">
      <div className="container mx-auto px-6 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3" onClick={() => setMobileOpen(false)}>
            <img src={WB_LOGO} alt="WB" className="h-11 w-11 object-contain rounded-lg" />
            <div className="hidden sm:block">
              <p className="text-white font-bold text-lg leading-tight">Weldon Braxton</p>
              <p className="text-gray-500 text-xs">College Football Coach</p>
            </div>
          </Link>

          <nav className="hidden xl:flex items-center space-x-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? 'text-white bg-blue-600/20'
                    : 'text-gray-400 hover:text-white hover:bg-gray-800'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center space-x-3">
            <Link to="/contact" className="hidden md:inline-block bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all">
              Get in Touch
            </Link>
            <button
              data-testid="mobile-menu-btn"
              className="xl:hidden text-gray-400 hover:text-white p-2"
              onClick={() => setMobileOpen(!mobileOpen)}
            >
              {mobileOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="xl:hidden bg-gray-950 border-t border-gray-800 pb-4">
          <nav className="container mx-auto px-6 pt-2 space-y-1">
            {NAV_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                onClick={() => setMobileOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === link.to
                    ? 'text-white bg-blue-600/20'
                    : 'text-gray-400 hover:text-white hover:bg-gray-800'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setMobileOpen(false)}
              className="block mt-3 bg-blue-600 text-white text-center font-semibold px-4 py-3 rounded-full"
            >
              Get in Touch
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
